const getters = {
  currentUser: state => {
    return state.user;
  },
  currentCity: state => {
    return state.currentCity;
  },
  currentMapCenter: state => {
    return state.currentMapCenter;
  },
  currentMerchant: state => {
    return state.currentMerchant;
  },
  currentPlaceID: state => {
    return state.currentPlaceID;
  },
}

export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/app/getters.js